
export function findItem (arr, value, key) {
  // TODO: 增加异常处理，判断参数类型
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] === value) {
      return arr[i]
    }
  }
  return {}
}

/*
* 数字每三位加逗号
* */
export function toThousands(number, char, showZero) {
  if (number) {
    let sign = ''// 是否带符号
    const arr = String(number).split('.')
    let num = arr[0]; let result = ''
    if (num[0] === '-' || num[0] === '+') {
      sign = num[0]
      num = num.slice(1)
    }
    while (num.length > 3) {
      result = ',' + num.slice(-3) + result
      num = num.slice(0, num.length - 3)
    }
    if (num.length > 0) result = num + result
    return arr[1] ? sign + result + '.' + arr[1] : sign + result
  } else {
    if (!showZero) {
      return char || '不限'
    } else {
      return number ?? char ?? '不限'
    }
  }
}